export const endorsements = {
    id: "endorsements",
    section: "user-endorsement",
    header: {
        style: "profile-section-header",
        content: "Endorsements"
    }
};

export const summary = {
    id: "summary",
    section: "user-summary",
    header: {
        style: "profile-section-header",
        content: "Summary",
    }
};

export const experience = {
    id: "experience",
    section: "user-experience",
    header: {
        style: "profile-section-header",
        content: "Experience"
    },
    // message: "Experience is common across all subscribed networks.",
    listStyle: "list-experience",
}

export const education = {
    id: "education",
    section: "user-education",
    header: {
        style: "profile-section-header",
        content: "Education"
    },
    // message: "Education is common across all subscribed networks.",
    listStyle: "list-education",
}

export const certificates = {
    id: "certificates",
    section: "user-certificates",
    header: {
        style: "profile-section-header",
        content: "Certificates"
    },
    // message: "Certificates are common across all subscribed networks.",
    listStyle: "list-certificates",
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/componentStyles.js